import { useState } from 'react'
import { AGES } from './constants'
import * as classes from './AgeGate.module.css'
import * as classesButton from './Button.module.css'
import { translate } from '../../locales/locales'
import { Locales } from '../../models/locales.model'

const getLocale = (): Locales => {
  // Safe fallback during build
  if (typeof window === 'undefined') {
    return (process.env.LANGUAGE as Locales) || ('en-CA' as Locales)
  }

  const path = window.location.pathname.toLowerCase()

  const isFrench =
    path === '/fr' || path.startsWith('/fr/')

  return isFrench
    ? ('fr-CA' as Locales)
    : ('en-CA' as Locales)
}

const locale = getLocale()
const logo = new URL('../../assets/Aurora_Proudly_Canadian_Logo-v2.svg', import.meta.url)

export const AgeGate = ({user}) => {
  const { location, remember: save } = user
  const [isAdult, setIsAdult] = useState(false)
  const onClickAge = user.setIsAdult
  const onClickLocation = user.setLocation
  const onClickRemember = user.setRemember
  const ageOfConsent = AGES[location || 'ON'] || 18

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <img
          className={classes.ageGateLogo}
          src={logo}
          alt={translate('logo')}
        />
        <h2 className={classes.heading}>{translate('select')}</h2>
        <div className={classes.locationWrapper}>
          {Object.keys(AGES).map((_location) => (
            <button
              className={`${classesButton.btn} ${location === _location ? classesButton.btnActive : ''}`}
              onClick={() => onClickLocation(_location)}
              key={_location}
            >
              {_location === 'OC' ? translate('international') : _location}
            </button>
          ))}
        </div>
        <div onClick={() => setIsAdult(!isAdult)} className={classes.checkboxWrapper}>
          <div className={classes.checkboxBox}>
            <div className={isAdult ? classes.checkboxInnerCheck : ''} />
          </div>
          <div className={classes.checkboxLabel}>
            {!location || location === 'OC'
            ? translate('confirm_int')
            : `${translate('confirm_age1')} ${ageOfConsent} ${translate('confirm_age2')}`}
          </div>
        </div>
        <div onClick={() => onClickRemember(!save)} className={classes.checkboxWrapper}>
          <div className={classes.checkboxBox}>
            <div className={save ? classes.checkboxInnerCheck : ''} />
          </div>
          <div className={classes.checkboxLabel}>
            {translate('shared')}
          </div>
        </div>

        <div className={classes.buttonWrapper}>
          <button
            className={classesButton.btn}
            disabled={!user.location || !isAdult}
            onClick={() => onClickAge(true)}
          >
            {translate('enter')}
          </button>
        </div>

        <div className={classes.paragraph}>
          {translate('consent')}
        </div>
      </div>
    </div>
  )
}
